import axios from "axios";
import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { API, Endpoints } from "../api/API";
import APPSETTINGS from '../appsettings.json';
import { userDataCtx } from "../hooks/applicationData";
import { doesAppRequireAdditionalClaims, getAppComponent, getNameDisplay, isAppDataValid } from "./Applications";
import { Facility, init_Facility, RegistrationValue } from "../interfaces/Interfaces";
import { checkTrailingSpace, verifyZip } from "../js/verificationFunctions";
import config from '../config.json';
import { event } from "jquery";

const Other: Facility = {
    accountId: '',
    ean: 'Other',
    parentEAN: '',
    facilityName: '',
    facilityAddress: '',
    facilityCity: '',
    facilityState: '',
    facilityZip: '',
    facilityCountry: '',
    isActive: '',
    reltio_UpdatedOn: '',
    reltio_CreatedOn: '',
    updatedOn: '',
    version: ''
};

interface AddAppProps {
    appName: string | null,
    lang: string | null,
    userCountry: string | null,
    setUserCountry: React.Dispatch<React.SetStateAction<string | null>>,
    objectId: string | null,
    appId: string | null,
    translate: () => void,
    // Whether to show the background work in progress spinner
    setBackgroundWIP: React.Dispatch<React.SetStateAction<boolean>>,
    setDisplayName: React.Dispatch<React.SetStateAction<string>>,
    email: string,
    accountNum: string,
    bdBioSciencesUserType: string | null,
    setBdBioSciencesUserType: React.Dispatch<React.SetStateAction<string | null>>,
    facZip: string,
    needFacility: boolean,
    needInstitution: boolean,
    appFeatures: any,
    countries?: Record<string, string>,
    global: any,
    getJWTDriver: () => Promise<boolean>,
    token: string,
    setTitleGuid: React.Dispatch<React.SetStateAction<string>>,
    customRegistrationValues: Array<RegistrationValue>,
    authLocale: string,
    updateRegistrationValues: () => void
}

const AddApplication = (props: AddAppProps) => {
    const [showJWTError, setShowJWTError] = useState(false);
    const {data: appData, setValidationFlags} = useContext(userDataCtx);
    const [appComponent, componentNeeded] = getAppComponent(props, null, null);
    const [facility, setFacility] = useState<Facility>({...init_Facility});
    const [formStep, setFormStep] = useState(1);
    const [selectedValue, setSelectedValue] = useState('');
    const [facilityZipCode, setfacilityZipCode] = useState("");
    const [updateFacZip, setUpdateFacZip] = useState(false);
    const selectRef = useRef<HTMLSelectElement>(null);
    const [dataLevel2, setLevel2Data] = useState({});
    const [dataLevel3, setLevel3Data] = useState({});
    const [isOpLoading, setIsOpLoading] = useState(false);
    const [curLocale, setCurLocale] = useState(props.lang);

    // State maintains list of facilities returned by API call
    const [facilitiesFromSearch, setFacilitiesFromSearch] = useState<Array<Facility>>([Other]);
    const [requiredInfoError, setRequiredInfoError] = useState<Array<string>>([]);
    const [validationError, setValidationError] = useState<Array<string>>([]);
    const [validFacility, setValidFacility] = useState(false);
    
    const CONFIG = config[process.env.NODE_ENV];
    const roleMap = {
        [CONFIG.learningAcademyLevel2]: 'Learner',
        [CONFIG.learningAcademyLevel3]: 'Learner Manager'
    };

    
    useEffect(() => {
        props.setTitleGuid('5c065f06-c0cd-4ddd-8413-ef190b6d09b5');
    }, []);


    //This is used to load care setting values for BDLA when existing user tries to register for BDLA
    useEffect(() => {
        
        if(componentNeeded){
            props.updateRegistrationValues();
        }
    }, [componentNeeded]);

     useEffect(() => {
        
        console.log('test here..');
        if(componentNeeded && props.customRegistrationValues != undefined){
            props.updateRegistrationValues();
        }
    }, [props.customRegistrationValues]);

    useEffect(() => {
        console.log("valid facility value.: "+ validFacility);
        if (validFacility) {
            if (selectRef.current) {
                if (validFacility) {
                    selectRef.current.selectedIndex = 0;
                }
                const event = new Event('change', { bubbles: true });
                selectRef.current.dispatchEvent(event);
            }
        }
    }, [validFacility]);

    const handleFacilityChange = (event: any) => {
        const facValue = event.target.value;
        setSelectedValue(facValue);
        getFacility(facValue);
    }

    const handleZipCodeChange = (event: any) => {
        const postalCode = event.target.value;
        setfacilityZipCode(postalCode);
    }
    const onCancel = () => {
        setUpdateFacZip(false);
    };

    const onUpdate = () => {
        getFacilities();
        setUpdateFacZip(false);
    };
    
    useEffect(() => {
        if (props.accountNum !== undefined && props.accountNum !== "") {           
            console.log('props.accountNum is there : ' + props.accountNum);
            var validFac = facilitiesFromSearch.filter(x => x.ean.toString() == props.accountNum.toString() );

            if(facilitiesFromSearch  && facilitiesFromSearch.length == 2){
                validFac  = facilitiesFromSearch.filter(x=> x.ean.toLocaleLowerCase() == "Other".toLocaleLowerCase())
            }

            if (validFac && validFac.length === 1) {
                console.log('found single valid facility');
                setValidFacility(true);
                setSelectedValue(JSON.stringify(validFac[0]));

                if (selectRef.current) {
                    const event = new Event('change', { bubbles: true });
                    selectRef.current.dispatchEvent(event);
                }
            } else {
                console.log('Multiple or zero matches — allow manual selection');
                // Multiple or zero matches — allow manual selection
                setValidFacility(false);
                facilitiesFromSearch.unshift(Other);
                setSelectedValue(""); // Clear selection
            }
        } else {
            setValidFacility(false);
            facilitiesFromSearch.unshift(Other);
            setSelectedValue(""); // Clear selection
        }
    }, [props.accountNum, facilitiesFromSearch]);
    
    useEffect(() => {        
        props.translate();
        
        if (!componentNeeded) {
           const role = props.appId ? roleMap[props.appId] : undefined;
           const careSetting = props.global?.LA_care_setting;
            if (props.appId == CONFIG.learningAcademyLevel2) {
                setLevel2Data({
                    LA_role: role,
                    ...(careSetting && { LA_care_setting: careSetting })
                });
            }
            if (props.appId == CONFIG.learningAcademyLevel3) {
                setLevel3Data({
                    LA_role: role,
                    ...(careSetting && { LA_care_setting: careSetting })
                });
            }
        }
    }, [props.lang])

    useEffect(() => {
        updateCurrentLocale();
    }, [props.authLocale, props.lang]);

    useEffect(() => {
        if (props.needFacility) {
            getFacilities()
        }
    }, [props.needFacility, props.facZip ])

    useEffect(() => {
        if (props.facZip) {
            setfacilityZipCode(props.facZip);
        }
        if (!props.accountNum && !props.facZip){            
            setUpdateFacZip(true);
        }
    }, [props.facZip]);

    const updateCurrentLocale = () => {
        //if authLocale provided use that else use lang prop
        let val = props.authLocale || props.lang;
        setCurLocale(val?.toLowerCase() || "en-us");
    }

    const getFacilities = async () => {
        
        props.setBackgroundWIP(true);
        setIsOpLoading(true);
        if (facility.facilityZip !== '' && props.facZip !== facility.facilityZip) {
            setFacility({ ...init_Facility });
        }
        
        let country = "";
        if (props.appFeatures?.limitOrgSearchToCountry) {
            country = props.userCountry ?? "";
        }
        let body: { ean?: string; zipCode?: string; country?: string };
        //console.log("props.accountNum: " + props.accountNum);
        let zipCode = updateFacZip ? facilityZipCode.toUpperCase() : props.facZip?.toUpperCase();

        if (props.accountNum !== "") {
            body = { "ean": props.accountNum };
            if (facilityZipCode !== "" || props.facZip) {
                body.zipCode = zipCode
            }
        } else {
            body = {
                "ean": props.accountNum,
                "zipCode": zipCode,
                "country": country
            };
        }
                
        console.log("GetFacilities Request Body.:", JSON.stringify(body));
        // const data =  await getFacilitiesApi(body);
        const data = await API.POST(body, Endpoints.GetFacilities, props.token);
        data.push(Other);
        setFacilitiesFromSearch(data);
        window.setTimeout(function(){
            props.setBackgroundWIP(false);
        },200);
        setIsOpLoading(false);
    }
    const getFacility = (event: any) => {
        let fac = JSON.parse(event);
        setTimeout(() => {
            setFacility({ ...fac });    
        }, 500);
    }

    const validateBeforeSave = () => {        
        let validSave = true;
        if(props.needFacility){
            // Confirm facility does not equal default facility (show error) and then assign to correct value in body (may neeed to pass global as a prop?)
          var currentErrors: Array<string> = [];
          var validationFlag = false;
          
          if (facilityZipCode && !verifyZip(facilityZipCode)){
            currentErrors = [...currentErrors, 'facilityZip'];
            validationFlag = true;
          }

          if (facility.facilityZip && !verifyZip(facility.facilityZip)) {
            currentErrors = [...currentErrors, 'facZipCode'];
            validationFlag = true;
          }

          setValidationError([...currentErrors]);

            if (
                validationFlag ||
                facility.facilityName === '' ||
                facility.facilityAddress === '' ||
                facility.facilityCity === '' ||
                facility.facilityState === '' ||
                facility.facilityZip === '' ||
                facility.facilityCountry === ''
            ) {
                currentErrors = [];
                //console.log("setting validation for current error");
                // Always check for EAN
                if (facility.ean === '' && !currentErrors.includes("ean")) {
                    currentErrors = [...currentErrors, 'facSelect'];
                }
                if (facility.ean === 'Other') {
                    if (
                        facility.facilityName === '' &&
                        !currentErrors.includes('facName')
                    )
                        currentErrors = [...currentErrors, 'facName'];
                    if (
                        facility.facilityAddress === '' &&
                        !currentErrors.includes('facAddress')
                    )
                        currentErrors = [...currentErrors, 'facAddress'];
                    if (
                        facility.facilityCity === '' &&
                        !currentErrors.includes('facCity')
                    )
                        currentErrors = [...currentErrors, 'facCity'];
                    if (
                        facility.facilityState === '' &&
                        !currentErrors.includes('facState')
                    )
                        currentErrors = [...currentErrors, 'facState'];
                    if (
                        facility.facilityZip === '' &&
                        !currentErrors.includes('facZipCode')
                    )
                        currentErrors = [...currentErrors, 'facZipCode'];
                    if (
                        facility.facilityCountry === '' &&
                        !currentErrors.includes('facCountry')
                    )
                        currentErrors = [...currentErrors, 'facCountry'];

                }
                //console.log("Current errors: "+ currentErrors);
                
                if (currentErrors.length > 0) {
                    //console.log("save validation: " + validSave)
                    validSave = false;
                    setRequiredInfoError([...currentErrors]);
                }
                else {
                    setRequiredInfoError([]);
                }
            } else {
                setRequiredInfoError([]);
            }
            //console.log("requiredInfoError: " + requiredInfoError);
        }
        else if (componentNeeded) {
            // Currently only used for Applciation specific data so putting validation logic here without any sort of conditional (only will make sense on the app data specific screen)
            validSave = validSave && isAppDataValid(props.appId, appData, setValidationFlags);
        }

        return validSave;
    }

    const onSave = async () => {     
        setShowJWTError(false);
        props.setBackgroundWIP(true);

        if(!validateBeforeSave()){
            props.setBackgroundWIP(false);
            return;
        }
        
        var body: any = {
            id: props.objectId,
            country: props.userCountry,
            email: props.email
        };  
       if (props.needFacility) {
            body.global = {...props.global, "facilities": [{...facility}]}
            if(props.accountNum != ""){
                body.global = {...body.global, "accountNumber": props.accountNum}
            }
            //updating the zipcode for user            
            //console.log("Change the ZIP CODE for User : "+ facilityZipCode);
            if(updateFacZip && (facilityZipCode!=null || facilityZipCode!=undefined)){
                body.global = {...body.global, "zipCode": facilityZipCode}
            }
        } else if (componentNeeded) {            
           body.applications = {
               [props.appId!]: appData,
           };

           //Save authlocale value only when app is BDLA, user object does not have authlocale value and query string should have auth locale value
           if (props.appId == CONFIG.learningAcademy || props.appId == CONFIG.learningAcademyLevel2 || props.appId == CONFIG.learningAcademyLevel3) {
               if (props.authLocale != "" && (props.global.authLocale == '' || props.global.authLocale == undefined)) {
                   body.global = { ...props.global, "authLocale": props.authLocale }
               }
           }
        }

        if (!componentNeeded) {
            const careSetting = props.global?.LA_care_setting;
            const role = props.appId ? roleMap[props.appId] : undefined;
            //console.log("Care Settings "+ careSetting);
            console.log("LA_role setting "+ role);
            if (props.appId == CONFIG.learningAcademyLevel2) {
                //console.log('data set in app 2');
                body.applications = {
                    [props.appId!]: {
                        LA_role: role,
                        ...(careSetting && { LA_care_setting: careSetting })
                    },
                };
            }
            if (props.appId == CONFIG.learningAcademyLevel3) {
                //console.log('data set in app 3');                
                body.applications = {
                    [props.appId!]: {
                        LA_role: role,
                        ...(careSetting && { LA_care_setting: careSetting })
                    },
                };
            }
        }

        try {
            //console.log('body JSON FINAL..: ' + JSON.stringify(body));
            const status = await API.POST(body, Endpoints.SaveUserData, props.token);
            if (!status) {
                //console.log("Save user error");
                props.setBackgroundWIP(false);
            } else {
                let resp = await props.getJWTDriver();
                if (!resp) {
                    setShowJWTError(true);
                }
            }
        } catch (e) {
            console.log(e);
            props.setBackgroundWIP(false);
        }
    }

    const RegisterBar = (): JSX.Element => {
        return (
            <>
                <div className="spacer"></div>
                <p className="buttons align-right">
                    {formStep === 2 && <button className="gray button 041b8acf-fafc-450f-8111-d7d0c36bba6b" onClick={() => setFormStep(formStep - 1)}>Back</button>}
                    {formStep === 1 && componentNeeded && props.needFacility ?
                    <button id="continue" className="button 394b58c5-ee63-4444-978a-c0373030b4f2" onClick={() => setFormStep(formStep + 1)} >Continue</button>
                    : <button className="button cfb63e0a-7122-45c2-88ab-c7b63920676b" onClick={onSave} >Register</button>}
                </p>
            </>
        )
    }

    const ApplicationNewData = () => {
      if (componentNeeded) {
        return appComponent;
      }
      return (
        <>
          {!props.needFacility && (
            <h3 className="bc5d2a31-31ce-4155-8210-9bf666a4d817">
              Thank you, no other information is required.
            </h3>
          )}
        </>
      );
    };

    const registrationStep = (): JSX.Element => {
        if(componentNeeded){
            const [appNameDisplay, _] = getNameDisplay(props);
            return (
                <>
                    <li className={formStep === 1 ?"on": ''}>1. {appNameDisplay}</li>
                    {props.needFacility && <li className={formStep === 2 ?"on": ''}>2. <span className="45b64a54-03de-4b7b-8e6f-d509b7baa321">Facility Information</span></li>}
                </>
            )
        }
        else if(props.needFacility){
            return (
                <li className="on">1. <span className="45b64a54-03de-4b7b-8e6f-d509b7baa321">Facility Information</span></li>
            )
        }
        
            return (
                <li className="on">1. <span className='e998840d-afd1-429d-9665-c493c0fc1dfb'>No other data required</span></li>
            )            
    }

    const registrationForm = (): JSX.Element => {
        if(componentNeeded && formStep === 1){
            return <ApplicationNewData />
        }
        else {
            return facilitySearch
        }
    }

    const facilitySearch = !props.needFacility ? <></>
    : <form className="facilitySearch-form" action="javascript:void(0);">
            <p className="21680e21-05a8-425d-8ff5-d04cb61ba812"> Please select a facility from the list below. If your facility is not found, select "Other" and enter the details of your facility manually.</p>
            {!validFacility && (
                <>
                    <div>
                        Facilities matching postal code:{" "}
                        {facilityZipCode === '' ? (
                            <b><span style={{ fontStyle: 'italic' }}>None</span></b>
                        ) : (
                            <b><span>{facilityZipCode}</span></b>
                        )}
                        {!updateFacZip ? <a onClick={() => setUpdateFacZip(true)} style={{ cursor: 'pointer' }}>
                            <b> (Change) </b></a>
                            : (
                                <>
                                    <div className="form-row">
                                        <div className="form-item">
                                            <label style={{marginRight: "10px"}} className="bf996cf8-5aa3-40e0-97b7-05ec72e8012b requiredLabel facilityZip" htmlFor="facilityZip" >
                                                Facility Zip/ Postal Code </label>
                                            <input type="text"
                                                placeholder="Facility Zip/ Postal Code"
                                                className={requiredInfoError?.includes('facilityZip') || validationError?.includes('facilityZip') ? 'error bf996cf8-5aa3-40e0-97b7-05ec72e8012b' : 'bf996cf8-5aa3-40e0-97b7-05ec72e8012b'}
                                                id="facilityZip" value={updateFacZip ? facilityZipCode : props.facZip}
                                                onChange={handleZipCodeChange} />
                                        </div>

                                        <div className="form-actions">
                                            <button className="a9268e4d-6667-4154-81f4-6c7804b03aa4 action-button" onClick={onUpdate}>Save</button>
                                            <button className="4e336164-de78-4b9c-98c4-63b4efa40470 action-button" onClick={onCancel}>Cancel</button>
                                        </div>
                                    </div>

                                </>
                            )}
                    </div>
                
            </>
            )}

    <p className={requiredInfoError.length === 0 ? "hide" : "accent-1-text"}>
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
        &nbsp;<span className="664eebfb-9b9d-488f-9778-2f09ffa5f99b">Please provide your</span> {requiredInfoError.map((value, index) => { return index === 0 ? $(`#${value}`).attr('placeholder') : ', ' + $(`#${value}`).attr('placeholder'); })}
    </p>     
    <p className={validationError.includes("facilityZip") && !requiredInfoError.includes("facilityZip") ? "accent-1-text" : "hide"}>
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility zipcode contains only numbers and hyphens.</span>
            </p>
    <p className={validationError.includes("facAddress") && !requiredInfoError.includes("facAddress") ? "accent-1-text" : "hide"}>
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
        &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility address is a valid address.</span>
    </p>
    <p className={validationError.includes("facAddress2") ? "accent-1-text" : "hide"}>
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
        &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility address 2 is a valid address.</span>
    </p>
    <p className={validationError.includes("facCity") && !requiredInfoError.includes("facCity") ? "accent-1-text" : "hide"}>
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
        &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility city is a valid city name.</span>
    </p>
    <p className={validationError.includes("facState") && !requiredInfoError.includes("facState") ? "accent-1-text" : "hide"}>
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
        &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility state is a valid state name.</span>
    </p>
    <p className={validationError.includes("facZipCode") && !requiredInfoError.includes("facZipCode") ? "accent-1-text" : "hide"}>
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
        &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility zipcode contains only numbers and hyphens.</span>
    </p>
    <p className={validationError.includes("facCountry") && !requiredInfoError.includes("facCountry") ? "accent-1-text" : "hide"}>
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
        &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility country is a valid country name.</span>
    </p>
            <div className="row">
                 <div className="col-sm-12">
                    <p><label className='7a1e14b4-695c-4b96-a23d-c9c14e078c8e requiredLabel a'>Facility Name</label><span className='requiredIcon'> *</span> </p>
                    <select name="facSelect" id="facSelect" ref={selectRef} value={selectedValue} placeholder="facility by selecting an option."
                        className={(validationError.includes("facSelect") || requiredInfoError.includes("facSelect")) ? 'error' : ''}
                        onChange={handleFacilityChange}>

                        {isOpLoading ? (
                            <option value="" disabled selected>
                                Loading...
                            </option>
                        ) : (

                            facilitiesFromSearch.map((fac: Facility, ind) => (
                                (ind == 0 &&  !validFacility)?
                                    <option className="de46a780-23ce-4e60-ba66-31d10e4fc884" value="" disabled hidden>Select a facility</option>
                                    :
                                    <option
                                        key={fac.ean}
                                        className={fac.ean === 'Other' ? "afde582f-1be5-4568-a6d2-fb5a67d60524" : ""}
                                        value={JSON.stringify(fac)}
                                    >
                                        {fac.ean !== 'Other'
                                            ? `${fac.facilityName} (${fac.facilityAddress})`
                                            : "Other"}
                                    </option>
                            ))

                        )

                        }


                    </select>

                </div>

            </div>

    <div className="row">
        <div className="col-sm-6">
            <p>
                <label className='7a1e14b4-695c-4b96-a23d-c9c14e078c8e requiredLabel'>Facility Name</label><span className='requiredIcon'> *</span>
                <input
                    type='text'
                    readOnly={facility.ean === "Other" ? false : true}
                    placeholder="Facility Name"
                    id='facName'
                    className={validationError.includes("facName") || requiredInfoError.includes("facName") ? 'error 7a1e14b4-695c-4b96-a23d-c9c14e078c8e' : '7a1e14b4-695c-4b96-a23d-c9c14e078c8e'}
                    value={facility.facilityName}
                    onChange={(e) => setFacility({ ...facility, facilityName: e.target.value })}
                    onBlur={checkTrailingSpace(
                        (e) => setFacility({ ...facility, facilityName: e.target.value })
                    )}
                />
            </p>
        </div>
        <div className="col-sm-6">
            <p>
                <label className="394830c0-8428-4660-80b2-a95b0b248aff requiredLabel">Facility Address</label><span className='requiredIcon'> *</span>
                <input
                    type="text"
                    readOnly={facility.ean === "Other" ? false : true}
                    placeholder="Facility Address"
                    id='facAddress'
                    className={validationError.includes("facAddress") || requiredInfoError.includes("facAddress") ? 'error 394830c0-8428-4660-80b2-a95b0b248aff' : '394830c0-8428-4660-80b2-a95b0b248aff'}
                    value={facility.facilityAddress}
                    //no trailing space check for address because there are spaces in addresses
                    onChange={(e) => setFacility({ ...facility, facilityAddress: e.target.value })}
                />
            </p>
        </div>
    </div>
    <div className="row">
        <div className="col-sm-6">
            <p>
                <label className="76150a37-fca8-4dda-bd64-d3a5f828cfe1 requiredLabel">Facility City</label><span className='requiredIcon'> *</span>
                <input
                    type='text'
                    readOnly={facility.ean === "Other" ? false : true}
                    placeholder="Facility City"
                    id='facCity'
                    className={validationError.includes("facCity") || requiredInfoError.includes("facCity") ? 'error 76150a37-fca8-4dda-bd64-d3a5f828cfe1' : '76150a37-fca8-4dda-bd64-d3a5f828cfe1'}
                    value={facility.facilityCity}
                    //ditto for city
                    onChange={(e) => setFacility({ ...facility, facilityCity: e.target.value })}
                />
            </p>
        </div>
        <div className="col-sm-6">
            <p>
                <label className="032b99bd-57b5-4afc-94bf-f6bd5da9fb49 requiredLabel">Facility State/ Province</label><span className='requiredIcon'> *</span>
                <input
                    type='text'
                    readOnly={facility.ean === "Other" ? false : true}
                    placeholder="Facility State/ Province"
                    id='facState'
                    className={validationError.includes("facState") || requiredInfoError.includes("facState") ? 'error 032b99bd-57b5-4afc-94bf-f6bd5da9fb49' : '032b99bd-57b5-4afc-94bf-f6bd5da9fb49'}
                    value={facility.facilityState}
                    //ditto for state
                    onChange={(e) => setFacility({ ...facility, facilityState: e.target.value })}
                />
            </p>
        </div>
    </div>
    <div className="row">
        <div className="col-sm-6">
            <p>
                <label className="bf996cf8-5aa3-40e0-97b7-05ec72e8012b requiredLabel">Facility Zip/ Postal Code</label><span className='requiredIcon'> *</span>                
                <input
                    type='text'
                    readOnly={facility.ean === "Other" ? false : true}
                    placeholder="Facility Zip/ Postal Code"
                    id='facZipCode'
                    className={validationError.includes("facZipCode") || requiredInfoError.includes("facZipCode") ? 'error bf996cf8-5aa3-40e0-97b7-05ec72e8012b' : 'bf996cf8-5aa3-40e0-97b7-05ec72e8012b'}
                    value={facility.facilityZip}
                    onChange={checkTrailingSpace(
                        (e) => setFacility({ ...facility, facilityZip: e.target.value })
                    )}
                />
            </p>
        </div>
        <div className="col-sm-6">
            <p>
                <label className="8124a58b-63a7-4760-b5d5-a36ef042cb4d requiredLabel">Facility Country</label><span className='requiredIcon'> *</span>
                <select
                    disabled={facility.ean === "Other" ? false : true}
                    placeholder="Facility Country"
                    id='facCountry'
                    className={validationError.includes("facCountry") || requiredInfoError.includes("facCountry") ? 'error' : ''}
                    value={facility.facilityCountry.toLowerCase()}
                    onChange={(e) => e ? setFacility({ ...facility, facilityCountry: e.target.value }) : null}
                >
                    <option value="" disabled className='8124a58b-63a7-4760-b5d5-a36ef042cb4d'>Facility Country</option>
                    {props.countries ? (Object.keys(props.countries).map((key: string) => {
                        return <option key={key} value={key}>{props.countries![key]}</option>
                    })) : <></>}
                </select>
            </p>
        </div>
    </div>
</form>

    return (
        <>
            <div className="row">
                <div className="col-sm-4 col-md-3">
                    <aside className="register">
                        <h4 className="h3-format c6e08adb-97ec-4b0c-a739-cf91fe34e6a9">Registration Steps</h4>
                            <ul className="no-bull">
                                {registrationStep()}
                            </ul>
                    </aside>
                </div>
                <div className="col-sm-8 col-md-9">
                    <div className="register-main match-height">
                        <div className="step">
                            <div className="header">
                                <div className="step-place">
                                    <span className="step-text 05017e1d-45fd-42db-ab4a-740649a6635c">Step</span>
                                    <span className="step-number">{formStep}</span>
                                </div>
                                <h2> <span className="be7f2fb9-50a4-4fbd-a7a6-5168f34e2532">Register for</span> {props.appName} </h2>
                            </div>
                        </div>
                        {props.appFeatures?.addApplicationCustomHtml ? <div style={{ margin: "0 10px" }} dangerouslySetInnerHTML={{ __html: props.appFeatures.addApplicationCustomHtml[curLocale ?? "en-us"] || props.appFeatures.addApplicationCustomHtml["en-us"] }} /> : null}
                        <div className="content">
                            {showJWTError ? <div className='error 99491c4e-2d49-48d9-8177-7679742e4766'>There was an issue processing your request, please try again. If the issue persists please contact support.</div> : <></>}
                            {registrationForm()}
                            <RegisterBar />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { AddApplication }
